import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation, useParams } from 'react-router-dom'
import {
  Title,
  HttpService,
  API,
  Common,
  Permissionkeys,
  Spinner,
  DateFormat
} from '../../config/react'
const AbandonedCartsDetails = () => {
  const urlParams = useParams()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const FilterPage = queryParams.get('page')
  const history = useHistory()
  const [loading, setLoading] = useState(true)
  const [IsAuth, setIsAuth] = useState(false)
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [AbandonedCartDetails, setAbandonedCartDetails] = useState([])
  const [Products, setProducts] = useState([])
  const [BillingAddressList, setBillingAddressList] = useState({})
  const [ShippingAddressList, setShippingAddressList] = useState({})
  console.log(AbandonedCartDetails, Products, BillingAddressList, ShippingAddressList)

  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.Products)) {
      history.push('/')
    }
    setIsAuth(true)
    setForceUpdate(!isForceUpdate)
    document.title = Title.AbandonedCartDetail
    GetAbandonedCartDetail()
  }, [urlParams.id])
  const GetAbandonedCartDetail = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetAbandonedCartDetail, param).then((response) => {
      setLoading(false)
      setAbandonedCartDetails(response.data.result[0][0])
      setProducts(response.data.result[0][0].products)
      if (
        response.data.result[1][0].addresses !== null &&
        response.data.result[1][0].addresses.filter((x) => x.address_type === 'billing').length > 0
      ) {
        setBillingAddressList(
          response.data.result[1][0].addresses.filter((x) => x.address_type === 'billing')[0]
        )
      }
      if (
        response.data.result[1][0].addresses !== null &&
        response.data.result[1][0].addresses.filter((x) => x.address_type === 'shipping').length > 0
      ) {
        setShippingAddressList(
          response.data.result[1][0].addresses.filter((x) => x.address_type === 'shipping')[0]
        )
      }
    })
  }
  const handleBackClick = () => {
    history.push('/sales/abandoned-carts', {
      state: {
        page: parseInt(FilterPage) === 0 ? 1 : parseInt(FilterPage)
      }
    })
  }
  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title">{Title.AbandonedCartDetail} </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={handleBackClick}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-lg-12 grid-margin stretch-card">
                  <div className="card">
                    <div className="card-body">
                      <div className="row justify-content-between">
                        <div className="col-md-5">
                          <div className="col-md-12">
                            <div className="card-header p-0 pb-2 mb-3">
                              <h3 className="title font-20">Customer Detail</h3>
                            </div>
                          </div>
                          <div className="address-info">
                            <table className="table table-striped table-borderless">
                              <tbody>
                                <tr>
                                  <td className="text-left">Customer</td>
                                  <td className="text-right">
                                    {AbandonedCartDetails.customer_name !== '' ? (
                                      <Link
                                        to={'/customers/edit/' + AbandonedCartDetails.customer_id}
                                        title="View Customer Details"
                                        target="_blank"
                                      >
                                        {AbandonedCartDetails.customer_name}
                                      </Link>
                                    ) : (
                                      <a href={'mailto:' + AbandonedCartDetails.email}>
                                        {AbandonedCartDetails.email}
                                      </a>
                                    )}
                                  </td>
                                </tr>
                                {/* <tr>
                                  <td className="text-left">Phone</td>
                                  <td className="text-right">{AbandonedCartDetails.phone}</td>
                                </tr> */}
                                <tr>
                                  <td className="text-left">Date</td>
                                  <td className="text-right">
                                    <DateFormat value={AbandonedCartDetails.updated_at} />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-md-5">
                          <div className="col-md-12">
                            <div className="card-header p-0 pb-2 mb-3">
                              <h3 className="title font-20">Cart Detail</h3>
                            </div>
                          </div>
                          <div className="address-info">
                            <table className="table table-striped table-borderless">
                              <tbody>
                                {/* <tr>
                                  <td className="text-left">Payment Status</td>
                                  <td className="text-right">
                                    {AbandonedCartDetails.payment_status === 'PENDING' ? (
                                      <label className="badge badge-warning">PENDING</label>
                                    ) : (
                                      <label className="badge badge-danger">
                                        {AbandonedCartDetails.payment_status}
                                      </label>
                                    )}
                                  </td>
                                </tr> */}
                                <tr>
                                  <td className="text-left">Is Reminder Sent?</td>
                                  <td className="text-right">
                                    {AbandonedCartDetails.is_reminded === 1 ? (
                                      <label className="badge badge-success">Sent</label>
                                    ) : (
                                      <label className="badge badge-danger">Not Sent</label>
                                    )}
                                  </td>
                                </tr>
                                <tr>
                                  <td className="text-left">Subtotal</td>
                                  <td className="text-right">{AbandonedCartDetails.order_total}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <div className="row justify-content-between">
                <div className="col-md-12">
                  <div className="card-header p-0 pb-2 mb-3">
                    <h3 className="title font-20">Items</h3>
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table text-center">
                      <thead>
                        <tr>
                          <th>Image</th>
                          <th>Name</th>
                          <th>System SKU</th>
                          <th>Price</th>
                          <th>Qty</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Products?.map((item, index) => {
                          return (
                            <tr key={index}>
                              <td>
                                <img
                                  src={item.image}
                                  alt={item.name}
                                  height={300}
                                />
                              </td>
                              <td>{item.name}</td>
                              <td>{item.sku}</td>
                              <td>{item.formated_price}</td>
                              <td>{item.qty}</td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default AbandonedCartsDetails
